export enum FileFormat {
    Zpl = 1,
    Pdf = 2,
    Csv = 3,
    ZipZpl = 4
}
